export default class ModalCaptchaValidate {

    static validateCaptcha(rule, value) {
        if (!value) {
            return Promise.resolve();
        }

        if (value && value.trim().length > 0) {
            return Promise.resolve();
        }

        return Promise.reject('请输入图形验证码！');
    }

}
